import { ChangeEvent, InputHTMLAttributes, useRef, useState } from "react";
import { Field } from "react-final-form";
import { useTranslation } from "react-i18next";
import { Col, Row } from "reactstrap";
import { translationHookOptions } from "../../app/localization/localization";

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  setTitle?: { index: number; mutator: (...args: any[]) => any };
  multiple?: boolean;
  enabledUploadedListFile?: boolean;
}

const CustomFileField = ({ name, setTitle, multiple, enabledUploadedListFile,...props }: Props) => {
  const [t] = useTranslation(["features"], translationHookOptions);
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [files, setfiles] = useState<File[]>();
  const handleUploadClick = () => {
    // 👇 We redirect the click event onto the hidden input element
    inputRef.current?.click();
  };

  return (
    <>
      <Row>
        <Col lg="12">
          <input
            type="button"
            onClick={handleUploadClick}
            value={t("attachment_button")}
          ></input>
        </Col>
      </Row>
      {files && files.length > 0 && (
        <>
        <Row style={{marginTop:"2px"}}>
        <Col   style={{ textAlign: "left" , color:'black'}}>
          {t("UploadedFiles")}
          </Col>
         </Row>
          </>
         )}
      <Row style={{marginTop:"1px"}}>
        {enabledUploadedListFile ?(<>
          <Col   style={{ textAlign: "left" , color:'black'}}>
          {files &&
            files.map((x, index) => (
              <> <li className="list-item-fileUplpaded" key={index}>
              {x.name}
           </li> </>
            ))}
        </Col>
        </>)
        :(<>
         <Col style={{ textAlign: "left", color: "black" }}>
          {files && files.length>0 &&
            (files.length === 1 ? (
              <li  className="list-item-fileUplpaded" style={{
               }}>  {files[0].name}</li>
                
            ) : (
              <li>{files.length} files</li>
            ))}
      </Col>
        </>)}
    
      </Row>
      <Field<FileList> name={name}>
        {({ input: { value, onChange, ...input } }) => (
          <>
            <input
              {...input}
              multiple={multiple}
              type="file"
              ref={inputRef}
              style={{ display: "none" }}
              onChange={({ target }) => {
                if (setTitle) {
                  const file = target.files && target.files.item(0);
                  if (file) {
                    setTitle.mutator(setTitle.index, file.name);
                  }
                }
                const files = Array.from(target.files || []);
                setfiles(files);
                onChange(target.files);
              }}
              {...props}
            />
          </>
        )}
      </Field>
    </>
  );
};

export default CustomFileField;
